"use strict";

exports.__esModule = true;
exports.parser = void 0;

var _core = require("./core");

var _config = require("./config");

var parser = (0, _core.compose)(_config.backgroundParser, _config.borderParser, _config.colorParser, _config.flexboxParser, _config.layoutParser, _config.outlineParser, _config.gridParser, _config.othersParser, _config.positionParser, _config.shadowParser, _config.spaceParser, _config.typographyParser, _config.transformParser, _config.transitionParser, _config.listParser);
exports.parser = parser;
//# sourceMappingURL=parser.js.map